// extracted by mini-css-extract-plugin
export default {"container":"Footer_container__MqVJ6","links":"Footer_links__J37fL"};